import { render, staticRenderFns } from "./Dashboard-filter.vue?vue&type=template&id=7d15b80c&scoped=true"
import script from "./Dashboard-filter.vue?vue&type=script&lang=js"
export * from "./Dashboard-filter.vue?vue&type=script&lang=js"
import style0 from "./Dashboard-filter.vue?vue&type=style&index=0&id=7d15b80c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d15b80c",
  null
  
)

export default component.exports